import { render, staticRenderFns } from "./af-recaptcha.vue?vue&type=template&id=6ba51104&"
import script from "./af-recaptcha.vue?vue&type=script&lang=ts&"
export * from "./af-recaptcha.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports